<template>
  <v-row>
    <v-col class="align-left pl-4" cols="4">
      <h3>Structure Unit ID:&nbsp;{{ structureUnit?.strUnitLabel }}</h3>
    </v-col>
    <v-col class="align-center" cols="4">
      <h3>
        Span Type:&nbsp;{{
          structureUnit.legacyStructureType
            ? configStore.getReferenceValue(REFERENCE_TABLE.STRUCTURE_UNIT_TYPE, structureUnit.legacyStructureType)
            : ``
        }}
      </h3>
    </v-col>
    <v-col class="align-right pr-4" cols="4">
      <h3>Unit Key:&nbsp;{{ structureUnit?.strUnitKey === -1 ? "" : structureUnit?.strUnitKey }}</h3>
    </v-col>
  </v-row>
</template>

<script setup>
import { computed } from "vue";
import { useSuperstructureStore } from "@/components/inspection/store/superStructure";
import { storeToRefs } from "pinia";
import { useConfigStore } from "@/stores/config";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";

const store = useSuperstructureStore();
const { superStructureData } = storeToRefs(store);
const configStore = useConfigStore();

const props = defineProps({
  strUnitKey: Number,
});

const structureUnit = computed(() => {
  return (
    superStructureData.value.structureUnits?.find((structureUnit) => structureUnit.strUnitKey === props.strUnitKey) || {
      strUnitLabel: "",
      legacyStructureType: "",
      strUnitKey: -1,
    }
  );
});
</script>
